import { Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import {Location} from '@angular/common';
import { DateService } from 'app/shared/date.service';
import { IntlService, CldrIntlService } from '@progress/kendo-angular-intl';
import { AppSettings } from 'app/shared/app-settings';
//import { IMyOptions } from 'mydatepicker';
import  '@progress/kendo-angular-intl/locales/he/all';
import { FormGroup , FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { stringify } from '@angular/core/src/util';
import { AdminService } from '../../admin.service';
import { Router } from '@angular/router';
import { refreshDescendantViews } from '@angular/core/src/render3/instructions';
import { IPrefixMobile } from '../../model/kod-mobile-prefix';
import { DebugRenderer2 } from '@angular/core/src/view/services';
import { setData } from '@telerik/kendo-intl';
import { debug } from 'util';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { IOved } from 'app/admin/interface/ioved.interface';
import { Moment } from "moment";
import { UserMessagesComponent } from 'app/shared/user-messages/user-messages.component';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { identifierModuleUrl } from '@angular/compiler';
import { routerNgProbeToken } from '@angular/router/src/router_module';
import { ConfirmService } from 'app/shared/dialog/confirm.service';
import { setTime } from '@progress/kendo-angular-dateinputs/dist/es2015/util';
import { Oved } from 'app/shared/model/oved';
import { IOvedPeilut } from 'app/admin/interface/ioved-peilut.interface';
import { ConfirmDialogComponent } from 'app/shared/dialog/confirm-dialog/confirm-dialog.component';
declare var require: any;



@Component({
  selector: 'app-peiluyot-admin-oved-details',
  templateUrl: './peiluyot-admin-oved-details.component.html',
  styleUrls: ['./peiluyot-admin-oved-details.component.css']
})
export class PeiluyotAdminOvedDetailsComponent implements OnInit {

    moment = require("moment");
    
    //controllers getters
    get ms_zehut_error() { return this.adminForm.get('ms_zehut'); }
    get shem_mishpacha() {return this.adminForm.get('shem_mishpacha');}
    get shem_prati() {return this.adminForm.get('shem_prati');}
    get kTelefon(){return this.adminForm.get('k_telefon');}
    get e_mail(){return this.adminForm.get('e_mail')};
    get tr_leida(){return this.adminForm.get('tr_leida')};
    get shem_status() {return this.adminForm.get('shem_status')}
    


    operationType:string = "הוספת";
    
    isOvedSearched:boolean=false;
    isGenderDropDownValid: boolean = true;
    isKminDropDownValid:boolean = true;
    isZakaut_Machazit_DropDownValid:boolean = true;
    mobilePrefixes:IPrefixMobile;
    isIdkun = false;
    isDeleteButton = false;
    isUpdateButton:boolean = false;
    isAddButton:boolean = false;
    submitButton:string ="הוספת עובד";
    is_Oved_Exists:boolean=false;
    ms_zehut_valid:boolean=true;
    returnMessage:string;
    isSucceeded:boolean=false;
    is_submit:boolean;
    encrypedetMsZehut: string = "";
    tr_leida_required:boolean = false;
    tr_leida_wrong_pattern:boolean = false;
    isKminReadOnly:boolean = true;

    minYear: number;
    maxYear: number

    adminForm = this.fb.group({
      shem_prati:['',[Validators.pattern("[א-ת\- ']*"),Validators.required]],
      shem_mishpacha:['',[Validators.pattern("[א-ת\- ']*"),Validators.required]],
      ms_zehut:['',Validators.compose([Validators.pattern("^[0-9]*$"), Validators.required])],
      k_kidomet:[0],
      k_telefon:['',Validators.required],
      k_min:[2],
      e_mail:['',Validators.required],
      tr_leida:[ ,Validators.compose([Validators.maxLength(10),Validators.minLength(10),Validators.required])],
      shem_status:['פעיל',Validators.required]

    })

    constructor(
      
      @Inject(LOCALE_ID) public localeId: string,
      public intlService: IntlService,
      private fb:FormBuilder,
      private _adminService:AdminService,      
      private location: Location,
      private userMessage: UserMessagesService,
      private dialog: MatDialog,
      private router: Router,
      private confirmService: ConfirmService
      ) { }
    
// TODO: remove oved from session on
//      - destroy

    ngOnInit() {
      debugger;
      this.encrypedetMsZehut = sessionStorage.getItem("encryptedMsZehut");
      sessionStorage.removeItem("encryptedMsZehut");
      this.userMessage.clearAll();
      this.getMobilePrefixes();
      this.localeId = "he-IL";
      //(<CldrIntlService>this.intlService).localeId = "he-IL";
      let oved: IOvedPeilut = JSON.parse(sessionStorage.getItem("oved")) as IOvedPeilut;
      //sessionStorage.removeItem("oved");    
      
      let isOvedDeleted :string = sessionStorage.getItem("ovedDeleted");
      
      console.log("init", oved, this.adminForm);
      if(oved && isOvedDeleted == "deleted")
      {
        this.adminForm.disable();
        this.isDeleteButton = true;
        this.operationType = "מחיקת"
        this.adminForm.patchValue({
          ms_zehut :oved.ms_zehut,
          shem_prati:oved.shem_prati,
          shem_mishpacha:oved.shem_mishpacha,
          k_kidomet:oved.k_kidomet,
          k_telefon:oved.k_telefon,
          k_min:oved.k_min,
          e_mail:oved.e_mail,
          tr_leida: this.moment.utc(oved.tr_leida),
          shem_status: oved.shem_status})
//          this.adminForm.disable();
      }

      if(oved && isOvedDeleted == null)
      {
        
        console.log("isaddbutton:", this.isAddButton);
        this.operationType = "עדכון"
        this.isIdkun= true;
        this.isUpdateButton = true;
        this.is_Oved_Exists=true;
        this.adminForm.patchValue({
          ms_zehut :oved.ms_zehut,
          shem_prati:oved.shem_prati,
          shem_mishpacha:oved.shem_mishpacha,
          k_kidomet:oved.k_kidomet,
          k_telefon:oved.k_telefon,
          k_min:oved.k_min,
          e_mail:oved.e_mail,
          tr_leida: this.moment.utc(oved.tr_leida),
          shem_status: oved.shem_status})
          console.log("admin form: ",this.adminForm);
      }
      if(!oved)
      {
        this.isAddButton = true;
      }

      
    // if (this.nirshamForm.get('llo_nitsul_zakaut').value > 0){
      //   setTimeout( () => {var fieldElement = <HTMLInputElement>document.getElementById('chkllo_nitsul_zakaut');
          
    // fieldElement.disabled = true;}, 2000 )
    }


    onMsZehutSearchChange(value:string){
      this.isOvedSearched = false;
    }
    updatePage(){
     
      this._adminService.updateOvedPeilut(this.adminForm.value).subscribe((res)=>{
        if(res.isSuccess)
        {
          debugger;
          this.isSucceeded=true;
          this.is_submit =true;
          this.returnMessage = res.message;
          this.userMessage.setSuccessMessage("הוספת עובד בוצעה בהצלחה");
          this.adminForm.disable();
        } 
        else
        {
            this.is_submit =true;
            this.isSucceeded = false;
            this.userMessage.setErrorMessage("הוספת עובד נכשלה");
        }
        },error=>{console.log("failed");
        this.isSucceeded=false;
        this.userMessage.setErrorMessage("הוספת עובד נכשלה");
      })
    }
    onSubmit(){
      //this.getOvedService();
      //this._adminService.addOved(this.adminForm.value).subscribe(()=>{console.log('succeeded')},error=>{console.log('failed')});
      
    }

    addOved()
    {

      //this.adminForm.value.tr_leida = this.setDate(this.adminForm.value.tr_leida);
      
      this._adminService.addOvedPeilut(this.adminForm.value).subscribe((res)=>{
        if(res.isSuccess)
        {
          debugger;
          this.isSucceeded=true;
          this.is_submit =true;
          this.returnMessage = res.message;
          this.userMessage.setSuccessMessage("הוספת עובד בוצעה בהצלחה");
          this.adminForm.disable();
        } 
        else
        {
            this.is_submit =true;
            this.isSucceeded = false;
            this.userMessage.setErrorMessage("הוספת עובד נכשלה");
        }
        },error=>{console.log("failed");
        this.isSucceeded=false;
        this.userMessage.setErrorMessage("הוספת עובד נכשלה");
      })

    }
    // getOvedService()
    // {
    
    //   this._adminService.getOvedPeilut(this.adminForm.value.ms_zehut).subscribe((res: ResultOfOperation<IOvedPeilut>)=>{
    //     if(res.isSuccess)
    //     {
    //       let oved: IOvedPeilut = res.data;
    //       this.isOvedSearched = true;
          
    //       //let dateString = oved.tr_leida.toString();
    //       //let tr_leida_formatted = new Date(dateString);
          
    //       this.is_Oved_Exists=true;
    //       this.adminForm.patchValue({
    //         shem_prati: oved.shem_prati,
    //         shem_mishpacha:oved.shem_mishpacha,
    //         k_kidomet:oved.k_kidomet,
    //         k_telefon:oved.k_telefon,
    //         k_min:oved.k_min,
    //         e_mail:oved.e_mail,
    //         tr_leida: oved.tr_leida, //tr_leida_formatted,

    //       })
    //       // this.isSucceeded=true;
    //       // this.is_submit =true;
    //       // this.returnMessage = res.returnMessage;
    //       // console.log('succeeded:',this.isSucceeded)} 
    //       // else{
    //       //   this.is_submit =true;
    //       //   this.isSucceeded = false;
    //       }
    //     },error=>{this.userMessage.setErrorMessage("בעיה בשליפת עובד");
    //   })
    // }

  getMobilePrefixes()
  {
    this._adminService.getMobilePrefixes().subscribe((res)=>{
    
      let data: IPrefixMobile = res.data;
      this.mobilePrefixes = data;
    })
  }  
    validateOvedmsZehut(ms_zehut)
    {
      console.log(this.ms_zehut_error.errors);
      let valid_zehut = this.validatemsZehut(ms_zehut);
      if (valid_zehut) {
          this.ms_zehut_valid = true;
      }
      else {
          this.ms_zehut_valid = false;
          this.adminForm.patchValue({ ms_zehut: "" });
          return;
      }
    }
    validatemsZehut(value) {

      if (value.length == 0)
          return false;
      console.log(value.length);


      var result = true;
      var first8 = null;
      var cifratBikoret = null;
      try {
          if (value.length == 10)
              first8 = value.substring(0, 9);
          else {
              if (value.length == 9)
                  first8 = "0" + value.substring(0, 8);
              else
                  first8 = "00" + value.substring(0, 8);
          }
          cifratBikoret = value.substring(value.length - 1);
          var checkDigits = 0 * 1;
          var temp = 0;
          var i = 0;

          for (i = 1; i <= 9; i++) {
              temp = first8.charAt(i - 1);
              checkDigits = temp * 1 + checkDigits * 1;
              if ((i % 2) == 1) {
                  checkDigits = temp * 1 + checkDigits * 1;
                  if (temp > 4)
                      checkDigits = checkDigits * 1 - 9;
              }
          }
          checkDigits = (10 - checkDigits % 10) % 10;
          result = (checkDigits * 1 == cifratBikoret * 1);
      }
      catch (e) { result = false; }
      if (value == "0")
          result = false;
      return result;
  }
  cleanForm(){
    this.location.back();
    for(var name in this.adminForm.controls) {
      (this.adminForm.controls[name]).patchValue('');
      sessionStorage.removeItem("oved");
    }
  }
  addOvedButton(){
    
    let isValidForm = this.validateDropDowns();  
    if(isValidForm){
      this.addOved();
    }
    else{
      this.userMessage.setErrorMessage("לא כל השדות מולאו באופן תקין");
    }
    
  }
  updateOved(){
      let isValidForm = this.validateDropDowns();  
      if(isValidForm)
      {
      this._adminService.updateOvedDetailsPeilut(this.adminForm.value).subscribe((res)=>{
        let oved = res;
        if(oved.isSuccess)
        {
          debugger;
          this.isSucceeded=true;
          this.is_submit =true;
          this.adminForm.disable();
          this.userMessage.setSuccessMessage("העובד עודכן בהצלחה");
          
        } 
          else{
            this.is_submit =true;
            this.isSucceeded = false;
          }
        },error=>{this.userMessage.setErrorMessage("בעיה בעדכון העובד");
        this.isSucceeded=false;
      })
    }
    else
    {
      this.userMessage.setErrorMessage("לא כל השדות מולאו באופן תקין");
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.adminForm.controls;
    for (const name in controls) {
        if (controls[name].invalid) {
            invalid.push(name);
        }
    }
    console.log(invalid);
  }

  validateDropDowns():boolean{
    if(this.adminForm.get('k_kidomet').value=="0"){
      this.isKminDropDownValid=false;}
      if(this.adminForm.get('k_min').value=="0"){
        this.isGenderDropDownValid=false; }  
  if(!this.isKminDropDownValid || !this.isGenderDropDownValid){
    return false;
  }
  else
  return true;
  }

  setDate(m: Date): Date {

    return new Date(Date.UTC(m.getFullYear(), m.getMonth(), m.getDate()));
    //return new Date(m.year + '-' + m.month + '-' + m.day);
  }

  isOvedExistsAndMsZehutValid()
  {
    this.validateOvedmsZehut(this.adminForm.value.ms_zehut);
    if(this.ms_zehut_valid)
    {
      this._adminService.IsOvedExistsPeilut(this.adminForm.value.ms_zehut).subscribe((res)=>{
        
        if(res.data && res.isSuccess)
        {
          this.isOvedSearched = true;   
          this.is_Oved_Exists=true;
          this.adminForm.patchValue({ ms_zehut: "" });
          
          }
        },error=>{console.log(error);
      })
    }
  }

  TrLeidaValidators()
  {
    let trLeida = this.adminForm.value.tr_leida;
    if(!this.moment.isMoment(trLeida))
    {
      this.tr_leida_wrong_pattern = true;
    }
    else
    {
      this.tr_leida_wrong_pattern = false;
    }
   
  }

  openDialog()
  {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {title: "מחיקת עובד",text: "האם אתה בטוח שברצונך למחוק את העובד?"};
    let dialogRef = this.dialog.open(ConfirmDialogComponent,dialogConfig);

    let httpResponse : boolean = undefined;
    let confirmSubscription = this.confirmService.confirm$.subscribe((confirm:boolean) => {
      if(confirm)
        {
            let oved: IOvedPeilut = JSON.parse(sessionStorage.getItem("oved")) as IOvedPeilut;
            oved.ms_zehut =  Number(this.encrypedetMsZehut);
            this._adminService.deleteOvedPeilut(oved).subscribe(response => {
              httpResponse = response.isSuccess;
              confirmSubscription.unsubscribe();
              this.confirmService.closeDialog();
            })
        }
      });

    dialogRef.afterClosed().subscribe((result:boolean) => {
      debugger;
      if(httpResponse)
      {
        
        this.router.navigateByUrl("admin/peiluyot-admin/peiluyot-admin-home");
        this.userMessage.setSuccessMessage("העובד הוסר בהצלחה");
      }
      else if(httpResponse == undefined)
      {
        this.router.navigateByUrl("admin/peiluyot-admin/peiluyot-admin-home");
      }
      else
      {
        this.router.navigateByUrl("admin/activities");
        this.userMessage.setErrorMessage("בעיה במחיקת עובד, אנא נסה שוב מאוחר");
      }
    });
  }

}
